export default "__VITE_ASSET__e5920869__"